import { type StartAutomationStep } from '../actionSectionTypes';

export const startAutomationStepRemoveVariable = (
  step: StartAutomationStep,
  variableName: string,
  errorIds: string[]
) => {
  const nextErrorIds: string[] = [];

  let nextStep = { ...step };
  let { hasError } = step;
  let { variableOverrideErrors, automationVariableOverrides } = step.details;

  if (step.details.automationVariable?.value === variableName) {
    hasError = true;
    nextStep = {
      ...step,
      hasError,
      details: {
        ...step.details,
        automationVariable: {
          ...step.details.automationVariable,
          deleted: true,
        },
      },
    };
    if (!errorIds.includes(step.id) && !nextErrorIds.includes(step.id)) {
      nextErrorIds.push(step.id);
    }
  }
  automationVariableOverrides = automationVariableOverrides.map(
    (automationVariableOverride) => {
      let variableError =
        variableOverrideErrors[automationVariableOverride.automationId] || {};

      const variableOverrides =
        automationVariableOverride.variableOverrides.map((variableOverride) => {
          const automationVariableError =
            variableOverride.valueSource === 'automation_variable' &&
            variableOverride.automationVariable?.value === variableName;

          const automationEntityVariableError =
            variableOverride.valueSource ===
              'automation_entity_variable_field' &&
            variableOverride.automationEntityVariable?.value === variableName;

          if (automationVariableError || automationEntityVariableError) {
            hasError = true;
            if (
              !errorIds.includes(step.id) &&
              !nextErrorIds.includes(step.id)
            ) {
              nextErrorIds.push(step.id);
            }
            const overrideError = {
              ...(variableError[variableOverride.variableToOverride] || {}),
            };

            variableError = {
              ...variableError,
              [variableOverride.variableToOverride]: {
                ...overrideError,
                variable: true,
              },
            };

            const { automationVariable, automationEntityVariable } =
              variableOverride;

            return {
              ...variableOverride,
              ...(automationVariable && automationVariableError
                ? {
                    automationVariable: {
                      ...automationVariable,
                      deleted: true,
                    },
                  }
                : null),
              ...(automationEntityVariable && automationEntityVariableError
                ? {
                    automationEntityVariable: {
                      ...automationEntityVariable,
                      deleted: true,
                    },
                  }
                : null),
            };
          }
          return variableOverride;
        });

      if (Object.keys(variableError).length) {
        variableOverrideErrors = {
          ...variableOverrideErrors,
          [automationVariableOverride.automationId]: variableError,
        };
      }

      return { ...automationVariableOverride, variableOverrides };
    }
  );

  return {
    nextStep: {
      ...nextStep,
      details: {
        ...nextStep.details,
        variableOverrideErrors,
        automationVariableOverrides,
      },
      hasError,
    },
    nextErrorIds,
  };
};
